import { shopifyAppProxyRequest, request } from '../utils/request.js';
import { getOptions } from '../utils/options.js';
import { RECHARGE_ADMIN_URL } from '../constants/api.js';

async function loginShopifyAppProxy() {
  const { storefrontAccessToken } = getOptions();
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const response = await shopifyAppProxyRequest("get", "/access", { headers });
  return { apiToken: response.api_token, customerId: response.customer_id, message: response.message };
}
async function loginShopifyApi(shopifyStorefrontToken, shopifyCustomerAccessToken) {
  return loginWithShopifyStorefront(shopifyStorefrontToken, shopifyCustomerAccessToken);
}
async function loginWithShopifyStorefront(shopifyStorefrontToken, shopifyCustomerAccessToken) {
  const { environment, environmentUri, storefrontAccessToken, storeIdentifier } = getOptions();
  const rechargeBaseUrl = RECHARGE_ADMIN_URL(environment, environmentUri);
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const {
    api_token: apiToken,
    customer_id: customerId,
    message
  } = await request("post", `${rechargeBaseUrl}/shopify_storefront_access`, {
    data: {
      customer_token: shopifyCustomerAccessToken,
      storefront_token: shopifyStorefrontToken,
      shop_url: storeIdentifier
    },
    headers
  });
  return apiToken ? { apiToken, customerId, message } : null;
}
async function loginWithShopifyCustomerAccount(shopifyCustomerAccessToken) {
  const { environment, environmentUri, storefrontAccessToken, storeIdentifier } = getOptions();
  const rechargeBaseUrl = RECHARGE_ADMIN_URL(environment, environmentUri);
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const {
    api_token: apiToken,
    customer_id: customerId,
    message
  } = await request("post", `${rechargeBaseUrl}/shopify_customer_account_api_access`, {
    data: {
      customer_token: shopifyCustomerAccessToken,
      shop_url: storeIdentifier
    },
    headers
  });
  return apiToken ? { apiToken, customerId, message } : null;
}
async function sendPasswordlessCode(email, options = {}) {
  const { environment, environmentUri, storefrontAccessToken, storeIdentifier } = getOptions();
  const rechargeBaseUrl = RECHARGE_ADMIN_URL(environment, environmentUri);
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const response = await request("post", `${rechargeBaseUrl}/attempt_login`, {
    data: {
      email,
      shop: storeIdentifier,
      ...options
    },
    headers
  });
  if (response.errors) {
    throw new Error(response.errors);
  }
  return response.session_token;
}
async function sendPasswordlessCodeAppProxy(email, options = {}) {
  const { storefrontAccessToken } = getOptions();
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const response = await shopifyAppProxyRequest("post", "/attempt_login", {
    data: {
      email,
      ...options
    },
    headers
  });
  if (response.errors) {
    throw new Error(response.errors);
  }
  return response.session_token;
}
async function validatePasswordlessCode(email, session_token, code) {
  const { environment, environmentUri, storefrontAccessToken, storeIdentifier } = getOptions();
  const rechargeBaseUrl = RECHARGE_ADMIN_URL(environment, environmentUri);
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const response = await request("post", `${rechargeBaseUrl}/validate_login`, {
    data: {
      code,
      email,
      session_token,
      shop: storeIdentifier
    },
    headers
  });
  if (response.errors) {
    throw new Error(response.errors);
  }
  return { apiToken: response.api_token, customerId: response.customer_id };
}
async function validatePasswordlessCodeAppProxy(email, session_token, code) {
  const { storefrontAccessToken } = getOptions();
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const response = await shopifyAppProxyRequest("post", "/validate_login", {
    data: {
      code,
      email,
      session_token
    },
    headers
  });
  if (response.errors) {
    throw new Error(response.errors);
  }
  return { apiToken: response.api_token, customerId: response.customer_id };
}
function getCustomerParams() {
  const { pathname, search } = window.location;
  const urlParams = new URLSearchParams(search);
  const token = urlParams.get("token");
  const subpaths = pathname.split("/").filter(Boolean);
  const portalIndex = subpaths.findIndex((path) => path === "portal");
  const customerHash = portalIndex !== -1 ? subpaths[portalIndex + 1] : void 0;
  if (!token || !customerHash) {
    throw new Error("Not in context of Recharge Customer Portal or URL did not contain correct params");
  }
  return { customerHash, token };
}
async function loginCustomerPortal() {
  const { customerHash, token } = getCustomerParams();
  const { environment, environmentUri, storefrontAccessToken, storeIdentifier } = getOptions();
  const rechargeBaseUrl = RECHARGE_ADMIN_URL(environment, environmentUri);
  const headers = {};
  if (storefrontAccessToken) {
    headers["X-Recharge-Storefront-Access-Token"] = storefrontAccessToken;
  }
  const response = await request("post", `${rechargeBaseUrl}/customers/${customerHash}/access`, {
    headers,
    data: {
      token,
      shop: storeIdentifier
    }
  });
  return { apiToken: response.api_token, customerId: response.customer_id };
}

export { loginCustomerPortal, loginShopifyApi, loginShopifyAppProxy, loginWithShopifyCustomerAccount, loginWithShopifyStorefront, sendPasswordlessCode, sendPasswordlessCodeAppProxy, validatePasswordlessCode, validatePasswordlessCodeAppProxy };
//# sourceMappingURL=auth.js.map
